import useAppraisalSettings from 'Hooks/useAppraisalSettings'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export const calculateTimeLeft = (settings: { appraisalClosingDate: string } | null) => {
  const targetDateTime = settings?.appraisalClosingDate
  if (targetDateTime) {
    const now = new Date()
    const targetDate = new Date(targetDateTime)
    const difference = targetDate.getTime() - now.getTime()

    // After the closing date, hide message after 1 day
    if (difference <= -86400000) return { hideMessage: true }
    if (difference <= 0) return { expired: true }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false,
    }
  }
  return null
}
const CountdownToDate = () => {
  const { settings } = useAppraisalSettings()

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(settings))

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(settings))
    }, 1000)

    return () => clearInterval(timer)
  }, [settings])

  if (!timeLeft || timeLeft.hideMessage) return null // Hide message after 1 day

  if (timeLeft.expired) {
    return (
      <div style={styles.expired}>
        🎉 The appraisal exercise for Q{settings?.appraisalQuarter} {settings?.appraisalYear} has
        ended!
      </div>
    )
  }

  return (
    <Link to='/appraisals' style={{ textDecoration: 'none' }}>
      <div className='mx-5'>
        <div style={styles.container}>
          <h2 style={styles.title}>
            Q{settings?.appraisalQuarter} {settings?.appraisalYear} Appraisal Exercise Ends In:
          </h2>
          <div style={styles.countdownContainer}>
            {renderTimeBlock(timeLeft.days, 'Days')}
            {renderTimeBlock(timeLeft.hours, 'Hours')}
            {renderTimeBlock(timeLeft.minutes, 'Minutes')}
            {renderTimeBlock(timeLeft.seconds, 'Seconds')}
          </div>
        </div>
      </div>
    </Link>
  )
}

// Render Time Block Function
const renderTimeBlock = (value: number | undefined, label: string) => (
  <div style={styles.timeBlock}>
    <div style={styles.timeValue}>{value}</div>
    <div style={styles.timeLabel}>{label}</div>
  </div>
)

// Styles
const styles = {
  container: {
    background: 'linear-gradient(135deg, #0E1F33, #0E1F33)',
    // background: "linear-gradient(135deg, #f4abcc, #e873a8)",
    borderRadius: '12px',
    padding: '20px',
    maxWidth: '500px',
    margin: '10px auto',
    textAlign: 'center',
    color: '#fff',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  } as React.CSSProperties,
  title: {
    marginBottom: '20px',
    fontSize: '1rem',
    fontWeight: 'bold',
    letterSpacing: '1px',
  } as React.CSSProperties,
  countdownContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  } as React.CSSProperties,
  timeBlock: {
    background: '#ffffff33',
    padding: '5px 8px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.2)',
  } as React.CSSProperties,
  timeValue: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#fff',
  } as React.CSSProperties,
  timeLabel: {
    marginTop: '5px',
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    fontWeight: '500',
    color: '#e0f7fa',
  } as React.CSSProperties,
  expired: {
    textAlign: 'center',
    color: '#e74c3c',
    fontWeight: 'bold',
    fontSize: '1rem',
    padding: '10px',
  } as React.CSSProperties,
}

export default CountdownToDate
